import LevelControls from './LevelControls';

export default LevelControls;



// WEBPACK FOOTER //
// ./src/components/LevelControls/index.js